export default __webpack_public_path__ + "static/descBanner-1d7d42ed6e43d43fa7566d5e51276c9d.png";